<template>
  <v-card>
    <v-card-title>Historial de Ajustes de Caja</v-card-title>
    <v-card-text>
      <v-btn color="primary" @click="cargarHistorial" :loading="cargando">Recargar</v-btn>
      <v-data-table
        :headers="headers"
        :items="ajustes"
        :loading="cargando"
        class="mt-3"
        :items-per-page="10"
        loading-text="Cargando..."
        no-data-text="No hay ajustes registrados."
      >
        <template v-slot:item.fecha="{ item }">
          {{ new Date(item.fecha).toLocaleString() }}
        </template>
        <template v-slot:item.diferencia="{ item }">
          <span :style="{ color: item.diferencia > 0 ? 'green' : (item.diferencia < 0 ? 'red' : 'black') }">
            {{ Math.round(Number(item.diferencia)) }}
          </span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Utiles from '../../Servicios/Utiles';
export default {
  name: 'HistorialAjustesCaja',
  data() {
    return {
      ajustes: [],
      cargando: false,
      headers: [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Usuario', value: 'usuario' },
        { text: 'Monto Registrado', value: 'monto_registrado' },
        { text: 'Monto Real', value: 'monto_real' },
        { text: 'Diferencia', value: 'diferencia' },
        { text: 'Comentario', value: 'comentario' }
      ]
    };
  },
  mounted() {
    this.cargarHistorial();
  },
  methods: {
    async cargarHistorial() {
      this.cargando = true;
      try {
        const res = await fetch(Utiles.generarURL('ajustes_caja_historial.php'));
        const data = await res.json();
        if (data.exito) {
          this.ajustes = data.ajustes;
        } else {
          this.ajustes = [];
        }
      } catch (e) {
        this.ajustes = [];
      } finally {
        this.cargando = false;
      }
    }
  }
};
</script> 


// WEBPACK FOOTER //
// src/components/Caja/HistorialAjustesCaja.vue